import { gql } from '@apollo/client';

export const UPDATE_SETTINGS = gql`
  mutation UpdateSettings($data: UpdateSiteSettingsInput!) {
    updateSiteSettings(data: $data)
  }
`;
